import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Albaran/addAlbaran`, method: 'POST', body: values, token: token})
}
